import React from 'react';
import Card from './Card';
import { useTheme } from '../context/ThemeContext';

const QuestionCard = ({ question, options, selectedOption, onSelect, questionNumber }) => {
    const { themeStyles } = useTheme();
    return (
        <Card maxWidth={true}>
            <div style={{ width: "100%" }}>
                <h2 className="text-lg font-bold" style={{ color: themeStyles.text }}>Q{questionNumber}. {question}</h2>
                <div className="mt-4">
                    {options.map((option, index) => (
                        <label
                            key={index}
                            className={`block p-2 border rounded mb-2 cursor-pointer ${selectedOption === option ? 'text-white font-bold' : 'bg-gray-100'
                                }`}
                            style={{ backgroundColor: selectedOption === option ? themeStyles.primaryColor : themeStyles.cardContentBackground }}
                        >
                            <input
                                type="radio"
                                name="option"
                                value={option}
                                checked={selectedOption === option}
                                onChange={() => onSelect(option)}
                                className="hidden"
                            />
                            {option}
                        </label>
                    ))}
                </div>

            </div>

        </Card>
    );
}

export default QuestionCard;
